import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

/**
 * @deprecated No longer available from Mastercard MATCH Pro API
 **/
const useInquiryMatchDetailsMutation = ({
	setInquiryMatchDetails,
}: {
	setInquiryMatchDetails: Function;
}) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			applicationId,
			selectedInquiryMatches,
		}: {
			selectedInquiryMatches: number;
			applicationId: string | number | undefined | any;
		}) =>
			autoChecklistService.getInquiryMatchDetails(
				applicationId,
				selectedInquiryMatches,
			),
		{
			onSuccess(data) {
				setInquiryMatchDetails?.(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useInquiryMatchDetailsMutation;
